<div class="row row--builder">
    <div class="col-sm-12"><h4 class="c-title--subsection text-uppercase">SESSIONS TO DISPLAY</h4></div>
</div>
<div class="row row--builder sessions-to-display-drawer--dropdown-buttons">
    <div class="sessions-to-display-drawer--filters">
        <div class="c-form-group">
            <div class="input-group">
                <input
                    id="sessionSearch"
                    cclFormInput
                    type="text"
                    [(ngModel)]="searchConfig.label"
                    class="c-form-group__input form-control"
                    placeholder="Search for Sessions..."
                    title="Search for Sessions"
                />

                <div class="input-group-append">
                    <span class="c-color-picker input-group-text"><i class="fa fa-search" aria-labelledby="sessionSearch"></i></span>
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <ng-container *ngFor="let item of selectedFilters">
        <div class="sessions-to-display-drawer--filters" *ngIf="item.item_id == 1">
            <div class="c-form-group">
                <ccl-multi-select-dropdown
                    [placeholder]="'Tracks: '"
                    [data]="this.sharedService.tracks"
                    [(ngModel)]="searchConfig.tracks"
                    [settings]="tracksDropdownSettings"
                ></ccl-multi-select-dropdown>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="sessions-to-display-drawer--filters" *ngIf="item.item_id == 2">
            <div class="c-form-group">
                <ccl-multi-select-dropdown
                    [placeholder]="'Types: '"
                    [data]="this.sharedService.types"
                    [(ngModel)]="searchConfig.types"
                    [settings]="typesDropdownSettings"
                ></ccl-multi-select-dropdown>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="sessions-to-display-drawer--filters" *ngIf="item.item_id == 3">
            <div class="c-form-group">
                <ccl-multi-select-dropdown
                    [placeholder]="'Tags: '"
                    [data]="this.sharedService.tags"
                    [(ngModel)]="searchConfig.tags"
                    [settings]="tagsDropdownSettings"
                ></ccl-multi-select-dropdown>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="sessions-to-display-drawer--filters" *ngIf="item.item_id == 4">
            <div class="c-form-group">
                <ccl-multi-select-dropdown
                    [placeholder]="'Levels: '"
                    [data]="this.sharedService.levels"
                    [(ngModel)]="searchConfig.levels"
                    [settings]="levelsDropdownSettings"
                ></ccl-multi-select-dropdown>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="showClearButton()" class="sessions-to-display-drawer--buttons">
        <ccl-basic-button (clickEvent)="clearAllFilter()" [className]="'c-btn--secondary c-btn--sm'"
            >Clear</ccl-basic-button
        >
    </div>
    <div class="sessions-to-display-drawer--buttons">
        <ccl-basic-button (clickEvent)="fetchSessions()" [className]="'c-btn--sm'">Search</ccl-basic-button>
    </div>
</div>

<div class="session-list sessions-to-display-drawer--list">
    <ccl-list
        [list]="sessions"
        [columns]="columns"
        [hideFilters]="true"
        [compact]="true"
        hasSelectableColumns="true"
        selectionProperty="id"
        (selectionChangeEvent)="selectSessions($event)"
        (filterChangeEvent)="loadFilteredSessions($event)"
        [(selectionDictionary)]="listSelection"
    >
        <span *ngIf="noSessions">No Session(s) found matching search criteria(s).</span>
    </ccl-list>
</div>
